<div
  fxLayout="row"
  fxLayoutGap="0.063rem"
  class="progress-bar"
  [class.delivery-note-workflow-skipped]="tour.deliverNoteWorkflowSkipped"
  >
  @for (i of [0,1,2,3,4]; track i) {
    <div
      class="balk"
      [class.done]="(tour.state | numericState) > i"
      [class.pending]="(tour.state | numericState) == i"
    ></div>
  }
</div>
